import {useBookingSummary} from 'presentation/modules/booking/shared/hooks/useBookingSummary';
import {useBookingStore} from 'presentation/modules/booking/shared/store/useBookingStore';
import {useCallChatRoom} from 'presentation/pages';
import {translations} from 'presentation/translations-new';

const {changeLocation} = translations['pt-br'].commons;
const {districtFlow} = translations['pt-br'].privateFlow.bookingFlow;
const {changeAppointmentLocal} = translations['pt-br'].privateFlow.bookingFlow.unitsFlow;

export function useHealthDistrictNotFoundState() {
	const {callChatRoom, IS_LOADING: callChatRoomIsLoading} = useCallChatRoom();
	const {handleChangeModals} = useBookingSummary();
	const {hasTelehealth} = useBookingStore(state => state.bookingData);

	const description = hasTelehealth
		? districtFlow.notFoundModal.descriptionAllHealth
		: districtFlow.notFoundModal.descriptionHealth;

	const changeLocationButtonLabel = hasTelehealth ? changeAppointmentLocal : changeLocation;

	return {
		callChatRoom,
		callChatRoomIsLoading,
		handleChangeModals,
		hasTelehealth,
		description,
		changeLocationButtonLabel,
	};
}
